import { OrderState } from "./OrderState";

export interface Vehicle {
  isCentralOffsiteLocation: boolean;
  vehicleIdentifier: string;
  inventoryId: string | null;
  bidTimestamp: string | null;
  invoice: {
    invoiceBreakdownUrl: string;
    invoicePaid: boolean;
    canPayInvoice: boolean;
    generateOpenBankingPaymentLink: string;
  };
  delivery: Delivery;
  lotNumber: string;
  vrm: string;
  vin: string;
  vehicleType: string;
  hasImages: boolean;
  generateImagesZipFileUrl: string;
  masterImageUrl: string;
  bidAmount: number;
  vatType: VatType;
  paymentStatus: PaymentStatus;
  primaryVehicleDescription: string;
  secondaryDescription: string;
  isEligibleForDelivery: boolean;
  isExport: boolean;
  isOrderReferenceAdded: boolean;
  orderReference: string | null;
  orderState: OrderState | null;
  isBookedForCollection: boolean;
  collectionStartDate: string | null;
  collectionEndDate: string | null;
  isVehicleOffsited: boolean;
  saleCode: string;
  saleDate: string | null;
  location: string | null;
  logBookPresent: boolean;
  saleSection: string | null;
  mileage: number | null;
  mileageWarranted: true | false | null;
  color: string | null;
  transmission: string | null;
  fuel: string | null;
  doors: number | null;
  grade: string | null;
  conditionReport: {
    rel: string;
    href: string;
    type: string;
  };
  mechanicalReport: {
    rel: string;
    href: string;
    type: MechanicalReportType;
  };
}

export interface Delivery {
  isEligible: boolean;
  isRevoked: boolean;
  isExport: boolean;
  isOrderReferenceAdded: boolean;
  isSundry: boolean;
}

export interface InvoiceLineItem {
  grossAmount: string;
  lineItemType: string;
  name: string;
  netAmount: string;
  vatAmount: string;
}

export interface InvoiceBreakdown {
  currencyCode: string;
  grossAmount: number;
  invoiceDate: string;
  invoiceNumber: string;
  lineItems: InvoiceLineItem[];
  netAmount: number;
  unpaidAmount: number;
  vatAmount: number;
}

export type MechanicalReportType =
  | "Standard"
  | "ElectricHybrid"
  | "EssentialChecks"
  | "FullInspection";

export enum PaymentStatusEnum {
  NoInvoice = "NoInvoice",
  InvoiceNotPaid = "InvoiceNotPaid",
  InvoicePaid = "InvoicePaid",
  PartnerFinanceInvoice = "PartnerFinanceInvoice",
  PartnerFinanceProcessing = "PartnerFinanceProcessing",
  PartnerFinanceFailed = "PartnerFinanceFailed",
  Processing = "Processing",
  Failed = "Failed",
}

export type PaymentStatus = `${PaymentStatusEnum}`;

export type VatType = "Unknown" | "Qualifying" | "Marginal" | "Commercial";
